import React from 'react';

import QR from 'qrcode.react';
import { connect } from 'react-redux';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';
import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';

import { fetchDevice } from '../store/actions/deviceActions';
import { fetchUser } from '../store/actions/userActions';
import { mobileDeviceId } from '../store/actions/appActions';
import { fetchFeaturedPlaylist, fetchHomePlaylist, fetchActivePlaylist, fetchMyPlaylist } from '../store/actions/playlistActions';
import { fetchSubscription } from '../store/actions/subscriptionActions';
import { FETCH_DEVICE_SUCCESS } from '../store/constants/deviceConstants';
import { BACK, ENTER } from '../util/remoteButtons';
import { fireAnalytics } from './utils';


export class Pair extends React.Component {
  async componentDidMount() {
    fireAnalytics("Page", "Pair Page Loaded");
    let pairInterval = null;
    var back = this.refs.back;
    back.focus();
    const pair = async () => {
      try {
        const deviceResult = await this.props.fetchDevice(this.props.app.SSSPDeviceId);
        if (deviceResult.errors === "Error") {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        if (deviceResult.type === FETCH_DEVICE_SUCCESS) {
          clearInterval(pairInterval);
          const emailId = deviceResult.payload.email;
          const { userId } = deviceResult.payload;
          fireAnalytics('Pair', 'App Paired', emailId);
          await this.props.mobileDeviceId(userId);
          // TODO: Move this into a redux action. Functionality is duplicated on the splash page.
          // if (!bdAuth.getToken()) {
          const response = await bdReq.post('/emailLogin', { emailId });
          if (response.success) {
            bdAuth._storeToken(response.body);
          }
          // }

          const fetchUser = await this.props.fetchUser();
          if (fetchUser.errors === "Error") {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchSubscription = await this.props.fetchSubscription();
          if (fetchSubscription.errors === "Error") {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchFeaturedPlaylist = await this.props.fetchFeaturedPlaylist();
          if (fetchFeaturedPlaylist.errors === "Error") {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchMyPlaylist = await this.props.fetchMyPlaylist();
          if (fetchMyPlaylist.errors === "Error") {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchHomePlaylist = await this.props.fetchHomePlaylist();
          if (fetchHomePlaylist.errors === "Error") {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchActivePlaylist = await this.props.fetchActivePlaylist('Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx');
          if (fetchActivePlaylist.errors === "Error") {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          clearInterval(this.onlineStatusInterval);
          this.props.history.push('/playlist/Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx');
        }
      } catch (e) {
        console.log(e);
      }
    };

    pairInterval = setInterval(() => pair(), 3000);

    return () => {
      clearInterval(pairInterval);
    };
  }

  render() {
    return (
      <div className="UpgradeWrapper">
        <img className="Logo1" src="assets/img/blackdove-logo-2020.png" alt="" style={window.innerWidth <= window.innerHeight ? { paddingTop: '50%' } : { paddingTop: '50px' }} />
        <div
          ref="back"
          onClick={() => { this.props.history.push('/featured'); }}
          onKeyDown={(e) => {
            e.stopPropagation();
            if (e.which === ENTER || e.which === BACK) { this.props.history.push('/featured'); }
          }}
          tabIndex="1"
          className="btn btn--round btn--dark btn--fill pairBackBtn"
        >Back
        </div>
        <QR className="QRCode" value={this.props.app.SSSPDeviceId} size={250} renderAs="svg" />
        <div className="TagLine">
          Pair this display with your mobile app
          <br />
          Scan the QR code provided above in the app.
        </div>
        <img className="BottomApps" src="assets/img/apps-image.png" alt="" />
      </div >
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  mobileDeviceId: (mobileId) => dispatch(mobileDeviceId(mobileId)),
  fetchDevice: (deviceId) => dispatch(fetchDevice(deviceId)),
  fetchUser: () => dispatch(fetchUser()),
  fetchSubscription: () => dispatch(fetchSubscription()),
  fetchFeaturedPlaylist: () => dispatch(fetchFeaturedPlaylist()),
  fetchMyPlaylist: () => dispatch(fetchMyPlaylist()),
  fetchHomePlaylist: () => dispatch(fetchHomePlaylist()),
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
});
export default connect((state) => {
  const { app } = state;
  return {
    app,
  };
}, mapDispatchToProps)(Pair);
